import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as config from "../../../../constants/config";
import * as handlers from "../../../../constants/handlers";
import * as settings from "../../../../constants/settings";
import * as navigationActions from "../../../../actions/navigationActions";
import * as rccActions from "../../../../actions/rccActions";
import * as formatHelper from "../../../../helpers/formatHelper";
import * as modelHelper from "../../../../helpers/modelHelper";

import Modal from "../../../global/generic/Modal";
import Table, {TABLE_VARIANT_SECONDARY} from "../../../global/generic/Table";

import imgLoader from "../../../../resources/img/loader.svg";

class ColorantRefillHistoryModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            offset: 0,
            listLength: 0
        };
    }

    componentDidMount() {
        this.props.dispatchInitMachineRefillHistoryAction();
    }

    handleCloseModalClick = () => {
        this.props.dispatchCloseFillCanisterHistoryModalAction();
    };

    getCanisterById = (id) => {
        let canister;
        for (canister of this.props.canisterList) {
            if (canister.id === id) {
                return canister;
            }
        }

        return null;
    };

    handleHistoryScroll = (event) => {
        if (
            Math.ceil(event.target.scrollHeight) === Math.ceil(event.target.scrollTop + event.target.clientHeight) &&
            this.state.offset <= this.props.refillHistory.length &&
            this.state.listLength < this.props.refillHistory.length
        ) {
            this.props.dispatchGetMachineRefillHistoryAction(this.state.offset + config.MAX_COLORANT_LIMIT);
            this.setState({
                offset: this.state.offset + config.MAX_COLORANT_LIMIT,
                listLength: this.props.refillHistory.length
            });
        }
    };

    getColorantRGB = (canister) => {
        if (canister === null || canister.colorant === null || canister.colorant.rgb === null) {
            return "";
        }

        return (
            <div
                className="color-square"
                style={{
                    backgroundColor: canister.colorant.rgb
                }}
            />
        );
    };

    getColorantName = (canister) => {
        if (canister === null || canister.colorant === null) {
            return "-";
        }

        return canister.colorant.name;
    };

    getTableHeader = () => {
        return modelHelper.buildTableRow([
            modelHelper.buildTableCell(<Translate value="general.canister" />),
            modelHelper.buildTableCell(<Translate value="general.colorant" />),
            modelHelper.buildTableCell(<Translate value="general.date" />),
            modelHelper.buildTableCell(
                <span>
                    {translate("general.amount")} ({this.props.rccUnit})
                </span>
            )
        ]);
    };

    getTableRows = () => {
        return this.props.refillHistory.map((record) => {
            let canister = this.getCanisterById(record.index);
            return modelHelper.buildTableRow(
                [
                    modelHelper.buildTableCell(
                        record.index,
                        "font-size-1_25em flex flex-align-center-vertical flex-wrap"
                    ),
                    modelHelper.buildTableCell(
                        <div className="flex flex-align-center-vertical flex-wrap">
                            {this.getColorantRGB(canister)}
                            <span className="">{this.getColorantName(canister)}</span>
                        </div>,
                        "font-size-1_25em flex flex-align-center-vertical flex-wrap"
                    ),
                    modelHelper.buildTableCell(
                        formatHelper.formatDateTimeUtc(record.date),
                        "font-size-1_25em flex flex-align-center-vertical flex-wrap"
                    ),
                    modelHelper.buildTableCell(
                        formatHelper.formatDecimal(record.amount),
                        "font-size-1_25em flex flex-align-center-vertical flex-wrap"
                    )
                ],
                "padding-15 ",
                "record-" + record.id
            );
        });
    };

    getTableColumns = () => {
        return [
            modelHelper.buildTableColumn("col-3"),
            modelHelper.buildTableColumn("col-3"),
            modelHelper.buildTableColumn("col-3"),
            modelHelper.buildTableColumn("col-3")
        ];
    };

    getContent = () => {
        if (this.props.loading) {
            return modelHelper.buildModalSection(
                <div className="loader width-100 text-align-center">
                    <img alt="loading" src={imgLoader} />
                </div>
            );
        }

        return modelHelper.buildModalSection(
            <Table
                variant={TABLE_VARIANT_SECONDARY}
                className="flex-child"
                tableHeader={this.getTableHeader()}
                tableRows={this.getTableRows()}
                tableColumns={this.getTableColumns()}
                onScroll={this.handleHistoryScroll}
            />
        );
    };

    render() {
        if (!this.props.machine.isConnected) {
            return (
                <Modal
                    tabId={this.props.tabId}
                    header={modelHelper.buildModalSection(<Translate value="navigation.menu.colorantRefillHistory" />)}
                    content={modelHelper.buildModalSection(
                        <Translate className="font-size-1_5em color-primary" value="general.rccIsNotConnected" />
                    )}
                    onClose={this.handleCloseModalClick}
                    styles={{minWidth: "60%", minHeight: "50%"}}
                />
            );
        }

        return (
            <Modal
                tabId={this.props.tabId}
                styles={{minWidth: "60%", minHeight: "50%"}}
                header={modelHelper.buildModalSection(<Translate value="navigation.menu.colorantRefillHistory" />)}
                content={this.getContent()}
                onClose={this.handleCloseModalClick}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        machine: store.rcc.machine,
        refillHistory: store.machine.refillHistory,
        canisterList: store.rcc.canisterList,
        rccUnit:
            store.rcc.machineConfigurationList === null ? settings.UNIT_ML : store.rcc.machineConfigurationList.unit,
        loading: store.rcc.requests.some((request) => request.method === handlers.MACHINE_HISTORY_REFILLS)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseFillCanisterHistoryModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.COLORANT_REFILL_HISTORY_MODAL));
        },
        dispatchInitMachineRefillHistoryAction: () => {
            dispatch(rccActions.getCanisterRefillHistory(null));
        },
        dispatchGetMachineRefillHistoryAction: (offset) => {
            dispatch(rccActions.getMachineRefillHistoryWithOffset(null, offset));
        }
    };
};

export default ColorantRefillHistoryModal = connect(mapStoreToProps, mapDispatchToProps)(ColorantRefillHistoryModal);
